import React from "react";
import PropTypes from "prop-types";
import styles from "./BreadcrumbSeparator.module.scss";

const BreadcrumbSeparator = ({ children }) => (
  <li aria-hidden="true" className={styles.breadcrumbSeparator}>
    {children}
  </li>
);

BreadcrumbSeparator.propTypes = {
  children: PropTypes.node.isRequired
};

export default BreadcrumbSeparator;
